"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccountingImportDoctolibCsvApiResponseSchema = void 0;
const zod_1 = require("zod");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const accouting_1 = require("./accouting");
exports.getAccountingImportDoctolibCsvApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(accouting_1.getAccountingApiEntitySchema).extend({
    workScheduleImport: zod_1.z
        .object({
        saved: zod_1.z.boolean(),
        periodFrom: zod_1.z.string(),
        periodTo: zod_1.z.string(),
    })
        .nullable(),
});
